<script setup>
import { isEmpty } from 'lodash'
import { provide } from 'vue'

const props = defineProps({
  provide: Object,
})

if (!isEmpty(props.provide)) {
  for (const [k, v] of Object.entries(props.provide)) {
    provide(k, v)
  }
}
</script>

<template>
  <slot />
</template>
